import { FccSeatbelt, FccSeatOccupancy } from '@backoffice-frontend/graphql'
import type { AdVehicleStreamAdVehicleSeatingVehicleFragment } from './seating.hook'

const getOccupiedSeats = (
  vehicle: AdVehicleStreamAdVehicleSeatingVehicleFragment,
) =>
  parseSeats(vehicle.adSeatsLayout).filter(
    seat => seat.occupancy === FccSeatOccupancy.Occupied,
  )

const getBuckledUpSeats = (
  vehicle: AdVehicleStreamAdVehicleSeatingVehicleFragment,
) =>
  getOccupiedSeats(vehicle).filter(
    seat => seat.seatbelt === FccSeatbelt.Fastened,
  )

export const getSeatingCounts = (
  vehicle: AdVehicleStreamAdVehicleSeatingVehicleFragment,
) => {
  const occupiedSeats = getOccupiedSeats(vehicle)
  const buckledUpSeats = getBuckledUpSeats(vehicle)

  return {
    seated: occupiedSeats.length,
    buckledUp: buckledUpSeats.length,
  }
}

const parseSeats = (
  adSeatsLayout: AdVehicleStreamAdVehicleSeatingVehicleFragment['adSeatsLayout'],
) => {
  const { __typename, ...seats } = adSeatsLayout ?? {}

  return Object.values(seats)
}
